import { memo } from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect } from 'react-router-dom';
import { v as bvVar } from 'bv';
import { ContentLayout } from 'bv-components';
import { extra6erSlug } from 'global-config';

import Logout from 'Index/logout';
import BetBuilderLauncher from 'Index/bet_builder_launcher';

import {
  Route,
} from '../shared';

import {
  Casino,
  Competitions,
  Virtuals,
  SportHome,
  SelfExclude,
  Lottery,
  BetCalculator,
  SportsHome,
  Offers,
  StaticPages,
  BetBuilderFixtures,
  BetBuilder,
  GreyHounds,
  SportSectionsCustomList,
  InPlayOverview,
  BetFinder,
  EventLevel,
  HorseRacing,
  NextEvent,
  Extra6er,
  ErrorPage,
  CrackTheCodeZone,
} from './lazy_components';

import { getHomeProductMap } from './helpers';

const { component: HomeComponent, props: homeProps } = getHomeProductMap();

const MainRoutesView = memo(({ location }) => (
  <Switch location={location}>
    <Route exact path="/">
      <HomeComponent {...homeProps} />
    </Route>
    <Route exact path="/sports">
      <SportsHome />
    </Route>
    <Route path={bvVar('casinoLobbies').map(({ slug }) => `/${slug}`)}>
      <Casino />
    </Route>
    <Route
      exact
      path={[
        '/sports/:sportId/meetings/:meetingId/(all)?/market_type/:marketTypeId',
        '/sports/:sportId/meetings/:meetingId/(all)?',
      ]}
    >
      <Competitions />
    </Route>
    { bvVar('virtualSportsIds').map((virtualSportId) => (
      <Route path={`/sports/${virtualSportId}`}>
        {/* Virtuals HREF should be correct for SEO, leaving this in case we have wrong CTAs */}
        <Redirect to="/virtuals" />
      </Route>
    )) }
    <Route path="/virtuals">
      <Virtuals />
    </Route>
    {/* in case we have a wrong URL for greyhounds (the meeting should not be in the URL) */}
    <Redirect
      from="/sports/1000/meetings/:meetingId/events/:eventId"
      to="/sports/1000/events/:eventId"
    />
    <Redirect from="/sports/1000/meetings" to="/sports/1000" />
    <Route path="/sports/1000/(events)?/:eventId?">
      <GreyHounds />
    </Route>
    <Route path="/sports/:sportId/bet-finder" feature="bet-finder">
      <BetFinder />
    </Route>
    <Route exact path={['/sports/:sportId', '/sports/:sportId/meeting/:meetingId/all']}>
      <SportHome />
    </Route>
    <Route path="/self_exclude">
      <SelfExclude />
    </Route>
    <Route path="/lottery">
      <Lottery />
    </Route>
    <Route path="/bet-calculator" feature="bet_calculator">
      <BetCalculator />
    </Route>
    <Route path="/logout">
      <Logout />
    </Route>
    <Route path="/offer">
      <Offers />
    </Route>
    <Route path="/pages">
      <StaticPages />
    </Route>
    <Route path="/bet_builder/fixtures">
      <BetBuilderFixtures />
    </Route>
    <Route
      path={['/bet_builder/:eventId/outcome/:outcomeId', '/bet_builder/:eventId']}
      feature="bet-builder"
    >
      <BetBuilder />
    </Route>
    <Route path="/sports/:sportId/sections/custom-list/:componentId/group/:groupIndex/item/:itemIndex">
      <SportSectionsCustomList />
    </Route>
    <Route path="/live">
      <InPlayOverview />
    </Route>
    <Route path="/sports/364/meetings/:meetingId/events/:eventId">
      <HorseRacing />
    </Route>
    <Route path={[
      '/sports/:sportId/meetings/:meetingId/events/:eventId/market_group/:marketGroupId',
      '/sports/:sportId/meetings/:meetingId/events/:eventId',
    ]}
    >
      <EventLevel />
    </Route>
    <Route path="/sports/:sportId/next_event">
      <NextEvent />
    </Route>
    <Route path={['/bet_builder_launcher/:eventId/outcome/:outcomeId', '/bet_builder_launcher/:eventId']}>
      <BetBuilderLauncher />
    </Route>
    {['standard', 'raffle'].map((type) => bvVar('crackTheCode')[type] && (
      <Route
        path={`/${type === 'raffle' ? 'raffle' : 'crack-the-code'}`}
        feature={type === 'raffle' ? 'raffle' : ''}
      >
        <CrackTheCodeZone type={type} />
      </Route>
    ))}
    <Route path={`/${extra6erSlug}`} feature="extra6er">
      <Extra6er />
    </Route>
    <Route>
      <ContentLayout showTabs>
        <ErrorPage />
      </ContentLayout>
    </Route>
  </Switch>
));

MainRoutesView.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
};

export default MainRoutesView;
